<div class='container' *ngIf='loadingState === loadingStates.LOADED; else loadingComponent'>
    <div class='mb-3 pt-3'>
        <div class='h3'>Account Activity Report Overview</div>
        <div class='lead'>
            In this page you can select:
            <ul>
                <li>To view the account report in the website in a table view ( very slow process ).</li>
                <li>To directly export the account report in a CSV format file ( recommended ).</li>
            </ul>
        </div>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center mt-lg-5">
        <h2 class="mb-4 fw-bold">Export Options</h2>

        <div class="d-flex flex-row gap-lg-5">
            <div class="text-center">
                <p class="fw-bold text-success" style="color: green; opacity: 0.7;">RECOMMENDED</p>
                <button class="ms-5 mt-2" mat-raised-button (click)="onExportCsvPressed()"
                        style="background-color: lightgreen; color: black;">
                    <mat-icon>insert_drive_file</mat-icon>
                    Export CSV
                </button>
            </div>

            <div class="text-center">
                <p class="fw-bold" style="color: red; opacity: 0.7;">VERY SLOW</p>
                <button class="ms-5 mt-2" mat-raised-button (click)="onNavigateToReportTableView()"
                        style="background-color: lightcoral; color: black;">
                    <mat-icon>table_view</mat-icon>
                    Go to report Table View
                </button>
            </div>

        </div>
    </div>
</div>
<ng-template #loadingComponent>
    <div class="container mt-5 d-flex flex-column align-items-center justify-content-center">
        <mat-progress-bar class='container' [value]='loadingProgress'></mat-progress-bar>
        <div>Loading Report Table... {{loadingStatus}}%</div>
    </div>
</ng-template>
